import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './languages/en'

Vue.use(VueI18n)

const messages = {
  en: en
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages
})

function translate (langObj) {
  if (!langObj) {
    return '-'
  }

  let lang = i18n.locale
  let fallback = i18n.fallbackLocale

  if (lang in langObj && langObj[lang]) {
    return langObj[lang]
  } else if (fallback in langObj && langObj[fallback]) {
    return langObj[fallback]
  } else {
    return '-'
  }
}

export { i18n, translate }
